import { CssBaseline, ThemeProvider } from '@mui/material';
import { Route, Routes } from 'react-router-dom';
import { AboutPage } from './pages/about.page';
import { HomePage } from './pages/home.page';
import { PrivacyPage } from './pages/policies/privacy.page';
import { Layout } from './shared/layout';
import { theme } from './theme';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/policies/privacy" element={<PrivacyPage />} />
        </Routes>
      </Layout>
    </ThemeProvider>
  );
}

export { App };
